export default __webpack_public_path__ + "static/media/aboutus1.de1459cb.jpg";